import type { MetaDescriptor, MetaFunction } from '@remix-run/react';
import { Container } from '~/components/Container';
import { SocialLinks } from './social-links';
import { SITE_META } from '~/defaults/site-meta';
import { generateOgTags } from '~/lib/open-graph';
import { generateTwitterTags } from '~/lib/twitter-card';

// Consider using type = profile

export const meta: MetaFunction = (): MetaDescriptor[] => {
  return [
    { title: 'About - unknownkind' },
    { name: 'description', content: SITE_META.description },
    ...generateTwitterTags(),
    ...generateOgTags(SITE_META),
  ];
};

export default function About() {
  return (
    <Container className="mt-16 sm:mt-32">
      <div className="grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:grid-rows-[auto_1fr] lg:gap-y-12">
        <div className="lg:pl-20">
          <div className="max-w-xs px-2.5 grayscale hover:filter-none lg:max-w-none">
            <img
              src="https://assets.unknownkind.com/portrait_800x800.jpg"
              alt="Portrait of Eddy Recio"
              sizes="(min-width: 1024px) 32rem, 20rem"
              className="aspect-square rotate-3 rounded-2xl bg-zinc-100 object-cover transition duration-0 hover:rotate-0 hover:duration-150 dark:bg-zinc-800"
            />
          </div>
        </div>
        <div className="lg:order-first lg:row-span-2">
          <h1 className="text-4xl font-bold tracking-tight text-zinc-800 sm:text-5xl dark:text-zinc-100">
            Hi 👋 &mdash; I’m Eddy. <br />I write about Business and Software.
          </h1>
          <div className="mt-6 space-y-7 text-base text-zinc-600 dark:text-zinc-400">
            <p>
              I love building software products and teams. In particular, I have
              a passion for the user experience. My love for interfaces is my
              outlet for combining art and science.
            </p>
            <p>
              Computers were love at first sight. Ever since I was a kid and saw
              the magic of computers. I distinctly remember seeing an arcade
              machine for the first time and being amazed. My first programing
              languages were BASIC, Pascal and C, which I used to build games
              and "business" software. Many years later, I was able to program
              robots, and many more business applications.
            </p>
            <p>
              In school, I love both math, art, science and history. I love
              combining these subjects. I believe there is a lot we can learn
              from the past, and use these lessons to build a better future. The
              magic of software has never faded, and provides me the unique
              opportunity to combine my love for art and science.
            </p>
            {/* <p>
              Today, I’m the founder of Planetaria, where we’re working on
              civilian space suits and manned shuttle kits you can assemble at
              home so that the next generation of kids really <em>can</em> make
              it to orbit — from the comfort of their own backyards.
            </p> */}
          </div>
        </div>
        <div className="lg:pl-20">
          <SocialLinks />
        </div>
      </div>
    </Container>
  );
}
